import useAjaxCall from "common/ui/useAjaxCall";
import { CancellationToken } from "common/ui/useCancellationToken";
import { withCancellationToken } from "common/http/httpService";
import futuresContractsService from "./futuresContracts.service";
import FuturesContract from "domain/futuresContract";
import { useMemo, useState } from "react";
import IsLoaded from "common/isLoaded";
import useStoreSelector from "common/redux/useStoreSelector";

type ByCommodity = {[id: number]: FuturesContract[]};

export default function useFuturesContracts(commodityId: number): IsLoaded<FuturesContract[]> {

    const [cachedFuturesContracts, setCachedFuturesContracts] = useState<ByCommodity>({});
    const updatedPrices = useStoreSelector(m => m.futuresContractPrices);

    useAjaxCall(async cxt => {
        if (commodityId == null) return;

        if (cachedFuturesContracts[commodityId] != null) return;

        loadFuturesContracts(cxt);
    }, [commodityId])

    const withLatestPrices = useMemo(() => {
        
        const fcs = cachedFuturesContracts[commodityId];
        return fcs == null
            ? { isLoaded: false, data: []}
            : { isLoaded: true, data: fcs.map(fc => ({...fc, ...updatedPrices[fc.symbol]}))};
    }, [updatedPrices, cachedFuturesContracts[commodityId]])

    async function loadFuturesContracts(cxt: CancellationToken) {
        const result = await withCancellationToken(futuresContractsService, cxt)
            .listFuturesContracts(commodityId);

        setCachedFuturesContracts(dps => ({
            ...dps,
            [commodityId]: result
        }));
    }

    if (commodityId == null) return {isLoaded: true, data: []};

    return withLatestPrices;
}
